module.exports = __webpack_public_path__ + "static/media/long-arrow-alt-left.c0daddfb.svg";